import { useRef, useState } from "react";
import { api, formatErr } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Paperclip, Upload, Trash2, FileText, Loader2 } from "lucide-react";
import { toast } from "sonner";

export const openFile = async (fid) => {
  const win = window.open("", "_blank");
  try {
    const r = await api.get(`/files/${fid}/download`, { responseType: "blob" });
    const url = URL.createObjectURL(r.data);
    if (win) win.location.href = url; else window.location.href = url;
    setTimeout(() => URL.revokeObjectURL(url), 60000);
  } catch (e) { if (win) win.close(); toast.error("File non disponibile"); }
};

export const Allegati = ({ coll, item, onChange, writable, etichette = ["Fattura", "Documento", "Altro"], serie = false, testId }) => {
  const ref = useRef();
  const [etichetta, setEtichetta] = useState(etichette[0]);
  const [busy, setBusy] = useState(false);
  const list = item.allegati || [];
  const upload = async (file) => {
    if (!file) return;
    setBusy(true);
    const fd = new FormData();
    fd.append("file", file); fd.append("etichetta", etichetta); fd.append("serie", serie ? "true" : "false");
    try { await api.post(`/allegati/${coll}/${item.id}`, fd, { headers: { "Content-Type": "multipart/form-data" } }); toast.success("Allegato caricato"); onChange(); }
    catch (e) { toast.error(formatErr(e.response?.data?.detail)); }
    setBusy(false);
  };
  const del = async (a) => {
    if (!window.confirm(`Eliminare ${a.filename}?`)) return;
    await api.delete(`/allegati/${coll}/${item.id}/${a.id}`); onChange();
  };
  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button size="sm" variant="ghost" className={`h-7 gap-1 px-2 ${list.length ? "text-primary" : "text-muted-foreground"}`} data-testid={testId}>
          <Paperclip className="w-3.5 h-3.5" />{list.length}
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-80 p-3" align="end">
        <div className="text-xs font-heading uppercase tracking-wider text-muted-foreground mb-2">Allegati</div>
        {list.length === 0 && <div className="text-sm text-muted-foreground mb-2">Nessun allegato</div>}
        <ul className="space-y-1 mb-2">
          {list.map((a) => (
            <li key={a.id} className="flex items-center gap-2 text-sm">
              <button type="button" onClick={() => openFile(a.id)} className="flex items-center gap-1.5 truncate hover:underline text-left flex-1" data-testid={`${testId}-open-${a.id}`}>
                <FileText className="w-3.5 h-3.5 shrink-0" /><span className="truncate">{a.filename}</span>
              </button>
              <span className="text-[10px] uppercase text-muted-foreground">{a.etichetta}</span>
              {writable && <Button size="icon" variant="ghost" className="h-6 w-6 text-destructive" onClick={() => del(a)} data-testid={`${testId}-del-${a.id}`}><Trash2 className="w-3 h-3" /></Button>}
            </li>
          ))}
        </ul>
        {writable && <div className="flex gap-2 pt-2 border-t">
          <Select value={etichetta} onValueChange={setEtichetta}>
            <SelectTrigger className="h-8 w-44 text-xs"><SelectValue /></SelectTrigger>
            <SelectContent>{etichette.map((e) => <SelectItem key={e} value={e}>{e}</SelectItem>)}</SelectContent>
          </Select>
          <input ref={ref} type="file" accept=".pdf,image/*" className="hidden" onChange={(e) => { upload(e.target.files[0]); e.target.value = ""; }} data-testid={`${testId}-input`} />
          <Button size="sm" className="h-8 gap-1 flex-1" disabled={busy} onClick={() => ref.current?.click()} data-testid={`${testId}-upload`}>
            {busy ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <Upload className="w-3.5 h-3.5" />}Carica PDF
          </Button>
        </div>}
      </PopoverContent>
    </Popover>
  );
};
